import { createDomain, fork, merge, Scope } from 'effector';
import { createGate } from 'effector-react';
import { storageApi } from '@shared/api/storage/storage';
import { Column, SortConfig } from '../types';
import {
  GetStoragePayload,
  GetStorageResponse,
  UpdateStoragePayload,
  UpdateStorageResponse,
} from '../types/savedSort';

export const SortToolbarDomain = createDomain();
export const SortToolbarGate = createGate();

export const scopes: { [key: string]: Scope } = {};

export const $config = SortToolbarDomain.createStore<SortConfig | null>(null);
export const $columns = SortToolbarDomain.createStore<Column[]>([]);
export const $column = SortToolbarDomain.createStore<string | null>(null);
export const $order = SortToolbarDomain.createStore<'asc' | 'desc' | null | undefined>(null);
export const $sortingReady = SortToolbarDomain.createStore<boolean>(false);

export const setConfig = SortToolbarDomain.createEvent<SortConfig>();
export const setColumn = SortToolbarDomain.createEvent<string | null>();
export const setOrder = SortToolbarDomain.createEvent<'asc' | 'desc' | null | undefined>();
export const setSortingReady = SortToolbarDomain.createEvent<boolean>();

/** Функция, которая устанавливается в onSortModelChange для изменения сортировки */
export const sortToolbarChanged = SortToolbarDomain.createEvent<{ field: string; sort?: 'asc' | 'desc' | null }[]>();

export const createSortToolbarScope = (name: string) => {
  if (scopes[name]) return scopes[name];
  scopes[name] = fork(SortToolbarDomain);

  return scopes[name];
};

export const $sortFromStorage = SortToolbarDomain.createStore<{ field: string; sort?: 'asc' | 'desc' | null }[] | null>(null);
export const saveSortToStorage = SortToolbarDomain.createEvent<{ field: string; sort?: 'asc' | 'desc' | null }[]>();

export const fxGetStorage = SortToolbarDomain.createEffect<
  GetStoragePayload,
  GetStorageResponse,
  Error
>().use(storageApi.getStorage);
export const fxUpdateStorage = SortToolbarDomain.createEffect<
  UpdateStoragePayload,
  UpdateStorageResponse,
  Error
>().use(storageApi.updateStorage);

export const $error = SortToolbarDomain.createStore<Error | null>(null);
export const clearError = SortToolbarDomain.createEvent();

export const errorOccured = merge([fxGetStorage.fail, fxUpdateStorage.fail]);
